import { type NavSection, TEAM_NAV, TEAMS } from "@/constants/appSidebar";
import { authStore } from "@/store/useAuthStore";
import { useActiveTeam } from "@/store/useTeamStore";

// adminOnly 항목을 걷어내고, 그 결과 비어버린 묶음은 감춘다.
export function visibleSections(
  sections: NavSection[],
  isAdmin: boolean,
): NavSection[] {
  return sections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => isAdmin || !item.adminOnly),
    }))
    .filter((section) => section.items.length > 0);
}

// 활성 팀의 메뉴를 현재 사용자 권한에 맞춰 걸러 돌려준다.
// 사이드바와 상단 헤더가 같은 목록을 쓰도록 한 곳에 둔다.
export function useNavSections(): NavSection[] {
  const activeTeam = useActiveTeam();
  const isAdmin = authStore((state) => state.user?.role === "admin");
  const teamNav = TEAM_NAV[activeTeam.id] ?? TEAM_NAV[TEAMS[0].id];

  return visibleSections(teamNav, isAdmin);
}
